namespace Matrix.Administration {
    export class GroupColumns {
        static columnsKey = 'Administration.Group';
    }
}
